function cov_i4r48uk42() {
  var path = "/app/src/constants/country-name-by-currency-map.ts";
  var hash = "0474647ce5784f3f1c4877d87addbe7d7d098989";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/constants/country-name-by-currency-map.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 79
        },
        end: {
          line: 10,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0474647ce5784f3f1c4877d87addbe7d7d098989"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_i4r48uk42 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_i4r48uk42();
export var COUNTRY_NAME_BY_CURRENCY_MAP = (cov_i4r48uk42().s[0]++, {
  AED: 'emirates',
  SAR: 'saudi',
  KWD: 'kuwait',
  BHD: 'bahrain',
  QAR: 'qatar'
});